// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XTvP-","content":"styles_content__3sd9Z","row":"styles_row__3UGoL","footer":"styles_footer__tHlrv","phraseLength":"styles_phraseLength__22ylD"};